import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {List} from 'immutable';
import {jsxActions as headerActions} from '../../../actions/Header/headerActions';
import { jsxActions as fetchEntitiesActions }      from '../../../actions/FetchEntities/fetchEntitiesActions.js';
import { jsxActions as assetsViewActions }        from '../../../actions/LocationPage/AssetsView/assetsViewActions';
import { jsxActions as assetsCassettesGridActions }        from '../../../actions/LocationPage/AssetsView/assetsCassettesGridActions';
import {jsxActions as createCassetteActions} from '../../../actions/LocationPage/AssetsView/createCassetteActions';
import {gridsNames} from '../../../enums/gridsNames';
import CassettesView from '../../../components/LocationPage/AssetsView/CassettesView/cassettesView';

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(assetsViewActions, dispatch),
      fetchEntitiesActions:    bindActionCreators(fetchEntitiesActions, dispatch),
      headerActions:        bindActionCreators(headerActions, dispatch),
      assetsCassettesGridActions:        bindActionCreators(assetsCassettesGridActions, dispatch),
      createCassetteActions:        bindActionCreators(createCassetteActions, dispatch),
    }
  }
}

let CassettesViewContainer = connect(
  (state) => {
    let sGrid = state.grid?.get(gridsNames.LOCATION_ASSET_CASSETTES) || null;
    return {
      sGrid:                  sGrid,
      sHasRows:               sGrid && sGrid.get('rows') ? sGrid.get('rows').size > 0 : false,
      sSelectedRowsData:      sGrid ? sGrid.get('selectedRowsData') : List(),
      sData:                  state.locationPage.getIn(['assetsView', 'cassettesView']),
      sLocationDetails:       state.locationPage.get('data').get('locationDetails'),
      sLoggedInUser :         state.login.get('loggedInUser'),
      sDataCreateCassette:     state.locationPage.get('createCassetteData'),
    };
  },
  mapDispatchToProps
)(CassettesView);

export default CassettesViewContainer;




